import Button from 'components/Button/Button';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import utilMessages from 'utils/messages';
import PencilIcon from './pencilIcon.svg';
import ProductNoteIcon from './productNoteIcon.svg';

export const NoteSm = styled.p`
  font-weight: 300;
  color: #596056;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const NoteAction = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  ${({ isHorizontal }) =>
    isHorizontal &&
    `
    flex-direction: row;
    align-items: center;
    gap: 4px;
  `}
`;

const AddNoteButton = styled(Button)`
  color: #136fd8 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 0 !important;
  display: flex;
  gap: 4px;
  align-items: center;
  width: fit-content;
`;

interface IProps {
  isShowNote?: boolean;
  isHorizontal?: boolean;
  isOnlyShowNoteIcon?: boolean;
  note?: string | ReactNode;
  onClickOpenNote: () => void;
}

const ProductNote: FC<IProps> = (props) => {
  const { isShowNote = true, isHorizontal, isOnlyShowNoteIcon, note, onClickOpenNote } = props;

  if (!isHorizontal) {
    return (
      <NoteAction>
        {isShowNote && !!note && <NoteSm>{note}</NoteSm>}
        <AddNoteButton type="link" size="small" onClick={onClickOpenNote}>
          {isOnlyShowNoteIcon ? <SVGIcon src={ProductNoteIcon} /> : <SVGIcon src={PencilIcon} />}
          {!isOnlyShowNoteIcon && <FormattedMessage {...utilMessages.note} />}
        </AddNoteButton>
      </NoteAction>
    );
  }
  return (
    <NoteAction isHorizontal={isHorizontal}>
      <AddNoteButton type="link" size="small" onClick={onClickOpenNote}>
        {isOnlyShowNoteIcon ? <SVGIcon src={ProductNoteIcon} width={20} height={20} /> : <SVGIcon src={PencilIcon} />}
        {!isOnlyShowNoteIcon && <FormattedMessage {...utilMessages.note} />}
      </AddNoteButton>
      {isShowNote && !!note && <NoteSm>{note}</NoteSm>}
    </NoteAction>
  );
};

export default ProductNote;
